module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 038.aab91459.jpg";